import { render, staticRenderFns } from "./WorkflowDiagram.vue?vue&type=template&id=438ed33e&scoped=true"
import script from "./WorkflowDiagram.vue?vue&type=script&lang=js"
export * from "./WorkflowDiagram.vue?vue&type=script&lang=js"
import style0 from "./WorkflowDiagram.vue?vue&type=style&index=0&id=438ed33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438ed33e",
  null
  
)

export default component.exports